module.exports = __webpack_public_path__ + "img/shelves.3768c0b2.png";